







































import { Action } from 'vuex-class'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { VAULT_TREE_CLOSE } from '@/store/entries/constants'
import Entry from '@/data/entry-model'

@Component({ name: 'vault-list-root' })
export default class VaultListRoot extends Vue {
    @Prop({ type: Object, required: true })
    vault!: Entry

    /**
     * Pop the vault tree stack and go up a directory
     */
    @Action(VAULT_TREE_CLOSE)
    closeVaultTree!: () => void

    get icon(): string {
        if (this.vault.icon === 'folder') {
            return 'folder-open'
        }
        return this.vault.icon
    }
}
